"use client";

import { useEffect, useRef } from "react";

import { FIFA_ASSET_VERSION } from "@/constants/vars.constants";
import { gsap, ScrollTrigger } from "@/lib/gsap";

import styles from "./ReasonWhy.module.scss";

gsap.registerPlugin(ScrollTrigger);

export default function ReasonLogo() {
  const logoRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!logoRef.current) return;

    const ctx = gsap.context(() => {
      gsap.set(logoRef.current, {
        opacity: 0,
        scale: 0.8,
        y: 100,
      });

      gsap.to(logoRef.current, {
        opacity: 1,
        scale: 1,
        y: 0,
        ease: "none",

        scrollTrigger: {
          trigger: ".reason-wrapper-trigger",
          start: "top+=500 top",
          end: "top+=1000 top",
          scrub: true,
        },
      });
    });

    return () => {
      ctx.revert();
    };
  }, []);

  return (
    <section className={styles.logoSection}>
      <div className={styles.logoBox} ref={logoRef}>
        <img
          src={`/fifa/fifa-hero-logo.webp?v=${FIFA_ASSET_VERSION}`}
          alt="FIFA Logo"
          title="FIFA Logo"
          loading="lazy"
        />
      </div>
    </section>
  );
}